import React from 'react'
import { LangflowUploader } from '../../components'

const Upload = () => {
  return (
    <div><LangflowUploader/></div>
  )
}

export default Upload